:root {
    --primary-rgb: 45, 149, 164;
    --secondary-rgb: 111, 114, 113;
    --warning-rgb: 255, 215, 95;
    --info-rgb: 0, 120, 255;
    --success-rgb: 12, 196, 114;
    --danger-rgb: 255, 67, 89;

    --primary-hex: #D5EAED;
    --warning-hex: #0a0a0a;
    --info-hex: #CCE5FF;
    --success-hex: #d4e6d8;
    --danger-hex: #FFD9DE;
}

.colored-toast {
    border-width: 0 0 0 6px !important;
    backdrop-filter: blur(10px);
}

.bg-success-transparent {
    background-color: var(--success-hex) !important;
}

.bg-danger-transparent {
    background-color: var(--danger-hex) !important;
    /*   color: rgb(var(--danger-rgb)) !important; */
}

.bg-info-transparent {
    background-color: var(--info-hex) !important;
    /*  color: rgb(var(--info-rgb)) !important; */
}

.bg-warning-transparent {
    background-color: var(--warning-hex) !important;
    /*    color: rgb(var(--warning-rgb)) !important; */
}

.icon-toast {
    width: 25px;
}

.close-toast {
    width: 2rem !important;
    height: 2rem !important;
    border: 0;
    top: -10px !important;
    left: -16px !important;
    background-color: #98989a;
}